import React, {useEffect, useState} from "react";
import Button from "../../../components/button";
import Breadcrumbs from "../../../components/breadcrumbs";
import Input from "../../../components/input";
import {toast, ToastContainer} from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import {useDispatch, useSelector} from "react-redux";
import {Link, useHistory} from "react-router-dom";
import {
    create_companies,
    clear_status_companie,
    CREATE_COMPANIES_SUCCESS,
    get_all_companies
} from "../../../redux/company";
import LoadingSpinner from "../../../components/loading-spinner";
import {Switch, Space} from "antd";

/** @module  Pages/Company/CreateCompany */

/**
 * Te devuelve un formulario que te permite crear una empresa
 * @returns {JSX.Element}
 *
 * @example
 * <CreateCompany />
 */

const CreateCompany = () => {
    const dispatch = useDispatch();
    const history = useHistory();
    /**
     * @constant {array} companies - Matriz de empresas
     *  Destrucción del estado de la tienda redux. */
    const {_create_companies} = useSelector((state) => state.company_module);

    /**
     * @constant {string} token - Token de autenticación
     *  Desestructuración del token del estado. */
    const {token} = useSelector((state) => state.users_module.login.data) || null;
    const [form, setForm] = useState({
        ruc: "",
        nombre: "",
        ruc_representante_legal: "",
        representante_legal: "",
        fondo_certificado: "",
        enviar_formulario: false,
    });

    const [isLoading, setIsLoading] = useState(false);

    useEffect(() => {
        if (_create_companies.status === 201) {
            toast.success("La empresa ha sido creada correctamente");
            dispatch(clear_status_companie(CREATE_COMPANIES_SUCCESS));
            setIsLoading(false);
            dispatch(get_all_companies(token));
            history.push("/empresas");
        } else if (_create_companies.status !== 0) {
            if (_create_companies.message) {
                toast.error(_create_companies.message);
                dispatch(clear_status_companie(CREATE_COMPANIES_SUCCESS));
                setIsLoading(false);
            }
        }
    }, [_create_companies, history, dispatch, token]);

    const handleChange = (e) => {
        setForm({
            ...form,
            [e.target.name]: e.target.value,
        });
    };

    const handleFileChange = (e) => {
        setForm({
            ...form,
            fondo_certificado: e.target.files[0],
        });
    };

    const handleCheckedChange = (checked) => {
        setForm({
            ...form,
            enviar_formulario: checked,
        });
    };

    const handleSubmit = (e) => {
        e.preventDefault();
        setIsLoading(true);
        //validate fields
        if (form.ruc === "") {
            toast.error("Debe ingresar el ruc");
            setIsLoading(false);
            return;
        }
        if (form.nombre === "") {
            toast.error("Debe ingresar el nombre");
            setIsLoading(false);
            return;
        }
        if (form.ruc_representante_legal === "") {
            toast.error("Debe ingresar el ruc del representante legal");
            setIsLoading(false);
            return;
        }
        if (form.representante_legal === "") {
            toast.error("Debe ingresar el representante legal");
            setIsLoading(false);
            return;
        }
        if (form.fondo_certificado === "") {
            toast.error("Debe seleccionar un fondo para el certificado");
            setIsLoading(false);
            return;
        }
        let data = new FormData();
        data.append("ruc", form.ruc);
        data.append("nombre", form.nombre);
        data.append("ruc_representante_legal", form.ruc_representante_legal);
        data.append("representante_legal", form.representante_legal);
        data.append("fondo_certificado", form.fondo_certificado);
        data.append("enviar_formulario", form.enviar_formulario);
        dispatch(create_companies(token, data));
    };

    return (
        <div className="app-content content">
            <ToastContainer/>
            {isLoading && <LoadingSpinner/>}
            <div className="content-overlay"/>

            <div className="content-wrapper">
                <div className="content-header row">
                    <div className="content-header-left col-12 mb-2 mt-1">
                        <Breadcrumbs
                            title="Empresas"
                            items={[
                                {label: "Empresas", link: "/empresas"},
                            ]}
                        />
                    </div>
                </div>
                <div className="content-body">
                    <div className="row">
                        <div className="col-12">
                            <form className="card" onSubmit={handleSubmit}>
                                <div className="card-header">
                                    <h4 className="card-title">Crear Empresa</h4>
                                </div>
                                <div className="card-body">
                                    <div className="row">
                                        <div className="col-md-6">
                                            <Input
                                                id="ruc"
                                                name="ruc"
                                                label="RUC"
                                                value={form.ruc}
                                                onChange={handleChange}
                                            />
                                        </div>
                                        <div className="col-md-6">
                                            <Input
                                                id="nombre"
                                                name="nombre"
                                                label="Nombre"
                                                value={form.nombre}
                                                onChange={handleChange}
                                            />
                                        </div>
                                        <div className="col-md-6">
                                            <Input
                                                id="ruc_representante_legal"
                                                name="ruc_representante_legal"
                                                label="Ruc representante legal"
                                                value={form.ruc_representante_legal}
                                                onChange={handleChange}
                                            />
                                        </div>
                                        <div className="col-md-6">
                                            <Input
                                                id="representante_legal"
                                                name="representante_legal"
                                                label="Representante legal"
                                                value={form.representante_legal}
                                                onChange={handleChange}
                                            />
                                        </div>
                                        <div className="col-md-6">
                                            <Input
                                                label="Fondo de certificado"
                                                name="fondo_certificado"
                                                type="file"
                                                onChange={handleFileChange}
                                            />
                                        </div>
                                        <div className="col-md-6 mt-2">
                                            <Space size={14} direction='horizontal'>
                                                <strong>Enviar formulario</strong>
                                                <Switch
                                                    checked={form.enviar_formulario}
                                                    checkedChildren="SI"
                                                    unCheckedChildren="NO"
                                                    onChange={handleCheckedChange}
                                                />
                                            </Space>
                                        </div>
                                    </div>
                                </div>
                                <div className="card-footer d-flex justify-content-end">
                                    <Link to="/empresas" className="btn btn-danger m-1">
                                        Cancelar
                                    </Link>

                                    <Button
                                        type="submit"
                                        className="btn btn-success"
                                        onClick={() => {
                                        }}
                                        text="Crear"
                                        theme="success"
                                        disabled={isLoading}
                                    />
                                </div>
                            </form>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default CreateCompany;
